<template>
	<div v-if="site">
		<h2>
			<router-link :to="`/sites/${site.id}`">
    			<i class="icon-minimal-left tim-icons" />
			</router-link>
			Inserisci motore <span v-if="site"> in {{site.name}}</span>
		</h2>
    	<engine-form :model="model" :on-submit="addSiteSubmit" submit-message="Crea" />
  </div>
  <loading v-else/>
</template>
<script>
import EngineForm from '@/components/Engines/EngineForm.vue'
// import SitesTable from './SitesTable.vue';
import { mapState, mapActions } from 'vuex'


export default{
  computed: {
    ...mapState({
      site: (state) => state.sites.site
    })
  },
  components: {
    EngineForm
  },
  mounted() {
    this.get(this.$route.params.siteId)
  },
  data() {
  	return {
  		model: {
        site: this.$route.params.siteId,
  			name: '',
        description: '',
        address: '',
        revisionRepeatDuration: 90,
        revisionsStatus: true,
  		}
  	}
  },
  watch: {
    site: function(newValue) {
      if (newValue !== null){
        this.model.site = newValue.id
      }
    }
  },
  methods: {
    ...mapActions('sites', {
      get: 'get'
    }),
    ...mapActions('engines', {
      create: 'create'
    }),
    addSiteSubmit() {
    	this.create({
              siteId: this.$route.params.siteId,
              engine: this.model
              })
    },	
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
  },
}	
</script>